import styled from '@emotion/styled';
import { colors } from '@/colors';

export const TabContainer = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 0px;
  padding: 0;
  width: 100%;

  ${({ variant }) => {
    switch (variant) {
      case 'default':
        return `border-bottom: 1px solid ${colors.NEUTRAL_3};`;
      case 'scoped':
      default:
        return 'border-bottom: 1px solid transparent';
    }
  }}
`;

const styDefault = `
  background: ${colors.NEUTRAL_0};
  color: ${colors.NEUTRAL_7};
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  border-bottom: 1px solid transparent;

  &:hover,
  &.active {
    color: ${colors.AJAIB_BLUE_5};
    font-weight: 700;
    position: relative;
  
    &:after {
      content: '';
      background: ${colors.AJAIB_BLUE_5};
      display: block;
      height: 100px;
      position: absolute;
      width: 100%;
      height: 4px;
      bottom: -2px;
      left: 0;
      border-radius: 4px 4px 0 0;
    }
  }
`;

const styScoped = `
  background: ${colors.NEUTRAL_1};
  border: 1px solid transparent;
  border-bottom: 1px solid transparent;

  color: ${colors.NEUTRAL_7};
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;

  &:hover,
  &.active {
    background: ${colors.NEUTRAL_0};
    border: 1px solid ${colors.NEUTRAL_2};
    border-bottom: 1px solid transparent;
    border-radius: 4px 4px 0 0;

    color: ${colors.NEUTRAL_10};
    font-weight: 700;
  }
`;

export const TabItem = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  color: ${colors.NEUTRAL_7};

  box-shadow: 0px 2px 0px transparent;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;

  ${({ size }) => {
    switch (size) {
      case 'sm':
        return 'padding: 8px 12px;';
      case 'md':
        return 'padding: 12px 16px;';
      case 'lg':
        return 'padding: 14px 16px;';
      default:
        return '';
    }
  }}

  ${({ variant }) => {
    switch (variant) {
      case 'scoped':
        return styScoped;
      case 'default':
      default:
        return styDefault;
    }
  }}
`;
